import AppLoader from "components/AppLoader";
import { cloneDeep } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import UserAPI from "restAPI/UserAPI";

export enum FeatureKeys {
  UI_ONLY = "UI_ONLY", // Dummy feature flag to hide components from UI only
  DASHBOARD_PRODUCT_FILTER = "DASHBOARD_PRODUCT_FILTER",
  FREEMIUM_FEATURES = "FREEMIUM_FEATURES",
  DOMAIN_CONFIG_SECURITY_SCORE_CARD = "DOMAIN_CONFIG_SECURITY_SCORE_CARD",
  IMPERVA = "IMPERVA",
  HIDE_BETA_TAG = "HIDE_BETA_TAG",
  HIDE_NEW_TAG = "HIDE_NEW_TAG",
  AUTOMOX = "AUTOMOX",
  DAILY_DIGEST_REPORT = "DAILY_DIGEST_REPORT",
  EXPLOITED_COLUMN = "EXPLOITED_COLUMN",
  AATI_SCORE_COLUMN = "AATI_SCORE_COLUMN",
  REPORTS_CUSTOM_WIDGET = "REPORTS_CUSTOM_WIDGET",
  BLACKDUCK_BIDIRECTIONAL_FLOW = "BLACKDUCK_BIDIRECTIONAL_FLOW",
  BI_DIRECTIONAL_STATUS_BLACKDUCK = "BI_DIRECTIONAL_STATUS_BLACKDUCK",
  DEPENDANT_FINDINGS_CONFIG = "DEPENDANT_FINDINGS_CONFIG",
  BI_DIRECTIONAL_STATUS_COVERITY = "BI_DIRECTIONAL_STATUS_COVERITY",
  CROSS_BU_FINDINGS_BY_TAG = "CROSS_BU_FINDINGS_BY_TAG",
  RISK_QUANTIFICATION = "RISK_QUANTIFICATION",
  ENABLE_FOR_REPORT_INGESTION_TOKEN = "ENABLE_FOR_REPORT_INGESTION_TOKEN",
  IN_PROGRESS_SLA = "IN_PROGRESS_SLA",
  EXPORT_COMMENTS_HISTORY = "EXPORT_COMMENTS_HISTORY",
  FINDING_DETAILS_PDF = "FINDING_DETAILS_PDF",
  PARTNER_FEATURES = "PARTNER_FEATURES",
  RISK_SCORE_3_0 = "RISK_SCORE_3_0",
  DISABLE_BIDIRECTIONAL_SYNC = "DISABLE_BIDIRECTIONAL_SYNC",
  TICKET_RISK_SCORE_WIDGET = "TICKET_RISK_SCORE_WIDGET",
  TICKET_SLA_MISSED_WIDGET = "TICKET_SLA_MISSED_WIDGET",
  TICKET_RISK_TIMELINE = "TICKET_RISK_TIMELINE",
  BU_CREATION = "BU_CREATION",
  SLA_STATUS_BREACHED_CUSTOM_FIELD = "SLA_STATUS_BREACHED_CUSTOM_FIELD",
  SNYK_APPEND_ORGANIZATION_IN_PROJECT = "SNYK_APPEND_ORGANIZATION_IN_PROJECT",
  JFROG_VISION_VDOO = "JFROG_VISION_VDOO",
  ARCHIVE_DELETED_PROJECTS = "ARCHIVE_DELETED_PROJECTS",
  DISCOVERY_CYCODE_REPO_NAME_WITH_PROJECT = "DISCOVERY_CYCODE_REPO_NAME_WITH_PROJECT",
  HACKERONEONE_BU_CHANGE = "HACKERONEONE_BU_CHANGE",
  HIDE_VERSION_IN_BLACKDUCK_PROJECT = "HIDE_VERSION_IN_BLACKDUCK_PROJECT",
  JFROG_XRAY_FETCH_REPOSITORY = "JFROG_XRAY_FETCH_REPOSITORY",
  CONFIGURE_PROJECT_DASHBOARD = "CONFIGURE_PROJECT_DASHBOARD",
  SNYK_PROJECTS_BY_TARGET = "SNYK_PROJECTS_BY_TARGET",
  TENABLE_INFRASTRUCTURE_DEPRECATED = "TENABLE_INFRASTRUCTURE_DEPRECATED",
  JIRA_TICKET_DISABLE_COMMENTS_SYNC = "JIRA_TICKET_DISABLE_COMMENTS_SYNC",
  NEXUS_LIFECYCLE_MULTI_STAGE_REPORT_SUPPORT = "NEXUS_LIFECYCLE_MULTI_STAGE_REPORT_SUPPORT",
  CYCODE_PULL_CLOUD_ACCOUNT_VIOLATIONS = "CYCODE_PULL_CLOUD_ACCOUNT_VIOLATIONS",
  CX_ONE_CONTAINER_SECURITY_INGESTION = "CX_ONE_CONTAINER_SECURITY_INGESTION",
  EXCEPTION_MODULE = "EXCEPTION_MODULE",
  JIRA_TICKET_CLOSURE_STATUS_SELECTION = "JIRA_TICKET_CLOSURE_STATUS_SELECTION",
  APPCHECK = "APPCHECK",
  SNYK_TARGET_ORIGIN = "SNYK_TARGET_ORIGIN",
  VERSIONS = "VERSIONS",
  UNIFIED_TICKET_TEMPLATE = "UNIFIED_TICKET_TEMPLATE",
  HIDE_DEVELOPER_INSIGHT = "HIDE_DEVELOPER_INSIGHT",
  PENTEST_MODULE = "PENTEST_MODULE",
  IGNORE_VERSION_FROM_PROJECT_NAME = "IGNORE_VERSION_FROM_PROJECT_NAME",
  NETSPARKER_SCAN_GROUP_DISCOVERY_NAME = "NETSPARKER_SCAN_GROUP_DISCOVERY_NAME",
  RUNBOOK_TICKET_STATUS_CHANGE = "RUNBOOK_TICKET_STATUS_CHANGE",
  MANDIANT_CTI = "MANDIANT_CTI",

  EXECUTE_TOOL_SCAN = "EXECUTE_TOOL_SCAN",
  HACKERONE_MANY_TO_ONE = "HACKERONE_MANY_TO_ONE",
  MICROSOFT_DEFENDER_FOR_ENDPOINT_ADVANCED_HUNTING = "MICROSOFT_DEFENDER_FOR_ENDPOINT_ADVANCED_HUNTING",
  RBVM_ASSETS = "RBVM_ASSETS",
  SONARQUBE_COMPONENT_NAME_WITH_KEY = "SONARQUBE_COMPONENT_NAME_WITH_KEY",
  ENABLE_ATS_INTEGRATION = "ENABLE_ATS_INTEGRATION",
  HIERARCHY_SEVERITY_MAPPING = "HIERARCHY_SEVERITY_MAPPING",
  SIMPLIFIED_ONBOARDING = "SIMPLIFIED_ONBOARDING",
  TICKETING_CUSTOM_SEVERITY_RISK_RATING = "TICKETING_CUSTOM_SEVERITY_RISK_RATING",
  RUNBOOK_SCHEDULED_RUNBOOK = "RUNBOOK_SCHEDULED_RUNBOOK",
  LEGACY_WIDGETS = "LEGACY_WIDGETS",
  CODE_CLASSIFICATION = "CODE_CLASSIFICATION",
  WEB_AGENT_DISABLED = "WEB_AGENT_DISABLED",
  ANYA_PERSONNAS = "ANYA_PERSONNAS",
  ENABLE_CHECKMARXONE_SCAN_FILTERS = "ENABLE_CHECKMARXONE_SCAN_FILTERS",
  NEW_TABLE_FILTER = "NEW_TABLE_FILTER",
  ENABLE_CONTAINER_DETAIL_WITHOUT_REGISTRY_CROWDSTRIKE = "ENABLE_CONTAINER_DETAIL_WITHOUT_REGISTRY_CROWDSTRIKE",
  RUNBOOK_HTTP_REQUEST_ACTION = "RUNBOOK_HTTP_REQUEST_ACTION",
  CUSTOM_RISK_ENABLED = "CUSTOM_RISK_ENABLED",
  MANAGE_SBOM = "MANAGE_SBOM",
  IRIUS_RISK_FETCH_FROM_V2_API = "IRIUS_RISK_FETCH_FROM_V2_API",
  GITHUB_BIDIRECTION_SUPPORT = "GITHUB_BIDIRECTION_SUPPORT",
  ENABLE_GOOGLE_SCIM_PROVISIONING = "ENABLE_GOOGLE_SCIM_PROVISIONING",
  MEND_FETCH_LICENSE_FINDINGS = "MEND_FETCH_LICENSE_FINDINGS",
  SBOM_FINDING_REDIRECTION = "SBOM_FINDING_REDIRECTION",
  UI_THEME = "UI_THEME",
  ENABLE_LEANIX_V4_SUPPORT = "ENABLE_LEANIX_V4_SUPPORT",
  AI_DISABLED = "AI_DISABLED",
  DASHBOARD_RBAC = "DASHBOARD_RBAC",
  ENABLE_GOOGLE_JIT_PROVISIONING = "ENABLE_GOOGLE_JIT_PROVISIONING",
  ENABLE_DEPRECATED_PRISMA_CLOUD_TWISTLOCK = "ENABLE_DEPRECATED_PRISMA_CLOUD_TWISTLOCK",
  OWASP_CWE_FILTER = "OWASP_CWE_FILTER",
  GITHUB_ISSUES_CONFIG = "GITHUB_ISSUES_CONFIG",
  EXCEPTION_MODULE_UPDATE = "EXCEPTION_MODULE_UPDATE",
  AI_OVERVIEW_DASHBOARD = "AI_OVERVIEW_DASHBOARD",
  AI_CODE_INSIGHTS = "AI_CODE_INSIGHTS",
  AI_ANYA_AGENT = "AI_ANYA_AGENT",
  AATIV2_SCORE = "AATIV2_SCORE",
  CXONE_MANAGE_SBOM = "CXONE_MANAGE_SBOM",
  AI_ANYA_REMEDIATION_ACTIONS = "AI_ANYA_REMEDIATION_ACTIONS",
  AI_ANYA_REMEDIATION_ACTIONS_DISABLED = "AI_ANYA_REMEDIATION_ACTIONS_DISABLED",
  AI_REMEDIATION_AUTO_LOAD = "AI_REMEDIATION_AUTO_LOAD",
  DISABLE_TAG_GLOBAL_FILTER = "DISABLE_TAG_GLOBAL_FILTER",
  NOWSECURE_LAST_SCAN_DATE_SUPPORT = "NOWSECURE_LAST_SCAN_DATE_SUPPORT",
  RISK_TIERS = "RISK_TIERS",
  ENABLE_GHAS_FOR_ENTERPRISE = "ENABLE_GHAS_FOR_ENTERPRISE",
  SCAN_FREQUENCY_LIMITS = "SCAN_FREQUENCY_LIMITS",
  AQL_AUTO_SUGGESTION = "AQL_AUTO_SUGGESTION",
  GITGUARDIAN_OCCURRENCE_BASED_FINDINGS = "GITGUARDIAN_OCCURRENCE_BASED_FINDINGS",
  FINDING_AQL_V2 = "FINDING_AQL_V2",
  AQL_V2_PREVIEW = "AQL_V2_PREVIEW",
  RESTRICTED_ROLE_ENABLE = "RESTRICTED_ROLE_ENABLE",
  WIZ_PULL_ROOT_PROJECTS = "WIZ_PULL_ROOT_PROJECTS",
  WIZ_ASSET_TYPE_TREE_SELECT = "WIZ_ASSET_TYPE_TREE_SELECT",
  FINITE_STATE_NEXT_GEN_API = "FINITE_STATE_NEXT_GEN_API",
  PRISMA_COMPUTE_ENABLE_IMAGE_VERSION_MAPPING = "PRISMA_COMPUTE_ENABLE_IMAGE_VERSION_MAPPING",
  REDIRECT_TO_NEW_PRODUCT_SUBPRODUCT_URL = "REDIRECT_TO_NEW_PRODUCT_SUBPRODUCT_URL",
  SLA_V2 = "SLA_V2",
  TAG_INHERITANCE_OVERRIDE = "TAG_INHERITANCE_OVERRIDE",
  GHAS_MAPPING_BASED_ON_GITHUB_STATUS = "GHAS_MAPPING_BASED_ON_GITHUB_STATUS",
  TICKET_FOR_RESOLVED_FINDINGS = "TICKET_FOR_RESOLVED_FINDINGS",
  SLA_TREND_V2 = "SLA_TREND_V2",
  AI_RISK_MANAGEMENT = "AI_RISK_MANAGEMENT",
  DISABLE_CORE_UI = "DISABLE_CORE_UI",
  ORCA_SECURITY_SHIFTLEFT_BRANCH_DISABLED = "ORCA_SECURITY_SHIFTLEFT_BRANCH_DISABLED",
  ASSET_AQL_V2 = "ASSET_AQL_V2",
  FINDING_DETAIL_OLD_VIEW = "FINDING_DETAIL_OLD_VIEW",
  CUSTOM_ATTR_IGNORE_CASE = "CUSTOM_ATTR_IGNORE_CASE",
  SPLIT_TOOL_PROJECT_DISCOVERED = "SPLIT_TOOL_PROJECT_DISCOVERED",
  DEPRECATED_LACEWORK_S3_FLOW_ENABLED = "DEPRECATED_LACEWORK_S3_FLOW_ENABLED",
  WIDGET_LOG_SCALE = "WIDGET_LOG_SCALE",
  TEAM_VIEW_CONSOLIDATED_ROWS = "TEAM_VIEW_CONSOLIDATED_ROWS",
  SNOW_ASSETS_MULTI_LEVEL_ATTRIBUTES = "SNOW_ASSETS_MULTI_LEVEL_ATTRIBUTES",
  ENABLE_SCALABLE_GROUP_ROLE_MAPPING_FLOW = "ENABLE_SCALABLE_GROUP_ROLE_MAPPING_FLOW",
  CRA = "CRA",
  JFROG_VISION_VDOO_VERSION_DISCOVERY = "JFROG_VISION_VDOO_VERSION_DISCOVERY",
  AUDIT_LOG_NEW_UI = "AUDIT_LOG_NEW_UI",
  GITHUB_SECRET_SCAN_REALTIME_INGESTION = "GITHUB_SECRET_SCAN_REALTIME_INGESTION",
  COMPONENT_SOURCE_TOOL_ENABLE = "COMPONENT_SOURCE_TOOL_ENABLE",
  SNOW_VR_DETECTIONS = "SNOW_VR_DETECTIONS",
}

export type FeatureFlagContentValuesType = { [key in FeatureKeys]?: boolean };

// used the same object so that it is available in popups as well.
const FeatureFlagContentValues: FeatureFlagContentValuesType = {};

const FeatureFlagContext = React.createContext(FeatureFlagContentValues);

export function useFeatureFlag() {
  return useContext(FeatureFlagContext);
}

function FeatureFlagProvider(props: {
  children: React.ReactNode[] | React.ReactNode;
}) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const { promise, cancel } = UserAPI.getFeatureFlags();

    promise
      .then((data) => {
        buildContextValue(data);
        setLoading(false);
      })
      .finally(() => setLoading(false));

    return cancel;
  }, []);

  if (loading) {
    return <AppLoader />;
  }
  return (
    <FeatureFlagContext.Provider value={FeatureFlagContentValues}>
      {props.children}
    </FeatureFlagContext.Provider>
  );
}

function buildContextValue(treatments: FeatureFlagContentValuesType) {
  for (const i in FeatureKeys) {
    const key = i as FeatureKeys;
    FeatureFlagContentValues[key] = treatments[FeatureKeys[key]];
    if (FeatureFlagContentValues[key] === undefined) {
      FeatureFlagContentValues[key] = false;
    }
  }
}

export default FeatureFlagProvider;

export function withFeatureFlags(
  Component: React.ComponentType<{
    featureFlags: FeatureFlagContentValuesType;
  }>,
) {
  return function FeatureFlagHOC(props: { [key: string]: unknown }) {
    const featureFlags = useFeatureFlag();
    return <Component {...props} featureFlags={featureFlags} />;
  };
}

export function getFeatureFlags_UNSAFE() {
  return cloneDeep(FeatureFlagContentValues);
}
